module.exports = __webpack_public_path__ + "static/media/pencil.373192d3.svg";